import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../../Dispute/SectionWrapper';
import InfoText from '../../atoms/InfoText';
import Avatar from '../../atoms/Avatar';

import { Table } from 'antd';
import { useParams } from 'react-router-dom';
import { useGetBuyerInfoDisputeQuery } from '../../../store/services/disputeService';

export default function AboutBuyer() {
  const { t } = useTranslation();

  const params = useParams();

  const { data } = useGetBuyerInfoDisputeQuery({
    disputeId: params?.disputeId,
  });

  const columns = [
    { title: '', dataIndex: 'name', key: 'name' },
    {
      title: '',
      dataIndex: 'value',
      key: 'value',
      className: 'text-end font-semibold',
    },
  ];

  const dataSource = [
    {
      name: 'Total orders',
      value: data?.payload?.totalOrders,
    },

    {
      name: 'Phone number',
      value: data?.payload?.phone,
    },

    {
      name: 'Email',
      value: data?.payload?.email,
    },
  ];

  return (
    <SectionWrapper title={t('components.disputeFeature.moreDetailsBuyer')}>
      <>
        <div
          data-testid="store-order-details-customer-avatar"
          className="space-y-1"
        >
          <InfoText text={t('components.disputeFeature.buyerDetails')} />

          <Avatar
            title={data?.payload?.name}
            image={data?.payload?.image}
            imageSize={16}
          />
        </div>

        <Table
          columns={columns}
          className="customTable"
          dataSource={dataSource}
          pagination={false}
          showHeader={false}
          size="middle"
        />
      </>
    </SectionWrapper>
  );
}
